@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

@number-input-default-min-height: 32px;

.number-input {
  display: flex;
  overflow: hidden;
  border: 1px solid @number-input--border-color;
  border-radius: 5px;
  min-width: 0;
  min-height: @number-input-default-min-height;
  background-color: @number-input--background-color;

  &.disabled {
    background-color: @number-input--disabled--background-color;
  }

  &.focused,
  &:hover {
    border-color: @number-input--hover--border-color;
  }

  input {
    flex: 1;
    border: none;
    min-width: 0;
    padding: 0;
    text-align: right;
    height: auto;
  }

  &.shrinkable {
    @media screen and (max-width: 1199px) {
      min-width: 32px;
      > input + div {
        display: none;
      }
      > input {
        text-align: center;
      }
    }
  }
}
